import RetirementOfPeriodRequestDataStore from '../../datastores/RetirementOfPeriodRequestDataStore';

export default class RetirementOfPeriodRequestDataStoreMock
  implements RetirementOfPeriodRequestDataStore
{
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async register(_data: {
    procedureId: number;
    reason: string;
    detail: string;
    contact: string;
    idDetail2: number;
    detail2: string;
    period: string;
    career?: string;
  }) {
    const data = {
      registerRetirementOfPeriodRequestProcedure: {
        error: null,
        requestId: 2001
      }
    };
    return data.registerRetirementOfPeriodRequestProcedure;
  }

  async cancel() {
    const data = {
      cancelRetirementOfPeriodRequestProcedure: {
        error: null,
        requestId: 1
      }
    };
    return data;
  }
}
